@if ((settingService.retailItems && menuService.isStoreRetail)) {
  <div #header class="header" [ngClass]="scroll">
    <ion-icon  name="options-outline" style="cursor: pointer;" (click)="filterNav()" style="margin-right: 4px; font-size: 20px; margin-top: 4px;"></ion-icon>
    <span  class="refine" style="cursor: pointer;" (click)="filterNav()">Refine</span>
  </div>
}

@if ((settingService.retailItems  && menuService.isStoreRetail)) {
  <div #overlay class="overlay hide"  (click)="close($event)">
    <div class="nav-container">
      <div class="navigation" #navigation>
        <div class="nav-heading"><h2>Refine</h2>
        <ion-icon name="close-circle" (click)="closeNav()" class="close-circle"></ion-icon>
      </div>
      <ng-container>
        <button id="location" name="accordion" class="accordion" (click)="openAccordion($event)">
          <span (click)="clickSpan($event)" id="location"  style="margin-left: 3.8px;" class="category">Store</span>
          <span  class="add" #add id="location" (click)="clickSpan($event)"></span>
          <span id="location" #accordionDescription class="accordion-description">{{storeName}} - {{location}}</span>
        </button>
        <div id="location" class="panel">
          <div style="display: flex" class="subcategory" id="3">
            <div style="width: 30%;">
              <label class="container">
                <input type="checkbox" checked="checked">
                <span class="checkmark"></span>
              </label>
            </div>
            <div style="width: 70%;"><span class="address">{{storeName}} - {{location}}</span></div>
          </div>
        </div>
      </ng-container>
      <ng-container>
        @for (department of menuService.menuDepartments; track department) {
          <div   (click)="selectedSubCategory($event)" data-name="departments" class="accordion" [id]="department.id">&nbsp;{{department.name.translations[translationService.getLanguage()]}}</div>
        }
      </ng-container>
      <ng-container>
        <button  data-name="color"  class="accordion" (click)="openAccordion($event)">
          <span data-name="color" (click)="clickSpan($event)"  style="margin-left: 3.8px;" class="category">{{'Order.Colors' | translate}}</span>
          <span data-name="color"   class="add" #add  (click)="clickSpan($event)"></span>
          <span data-name="color" #accordionDescription class="accordion-description" (click)="clickSpan($event)"></span>
        </button>
        <div data-name="color"  class="panel">
          <div data-name="color" class="box">
            @for (color of menuService.itemColors; track color; let i = $index) {
              <div data-name="color" class="mini"  [class.minitop]="i<4" (click)="selectedSubCategory($event,color.itemId)" [id]="color.id">{{color.name.translations[translationService.getLanguage()]}}</div>
            }
          </div>
        </div>
      </ng-container>
      <ng-container>
        <button data-name="size" class="accordion" (click)="openAccordion($event)">
          <span  data-name="size" (click)="clickSpan($event)"  style="margin-left: 3.8px;" class="category">{{'Order.Size' | translate}}</span>
          <span  data-name="size" class="add" #add  (click)="clickSpan($event)"></span>
          <span  data-name="size" #accordionDescription class="accordion-description" (click)="clickSpan($event)"></span>
        </button>
        <div  data-name="size" class="panel">
          <div data-name="size" class="box">
            @for (size of menuService.itemSize; track size; let i = $index) {
              <div data-name="size" class="mini" [class.minitop]="i<4"  (click)="selectedSubCategory($event,size.itemId)" [id]="size.id" >{{size.abbreviation.translations[translationService.getLanguage()]}}</div>
            }
          </div>
        </div>
      </ng-container>
      @if (menuService.itemBrands.length>0) {
        <button data-name="brands" class="accordion" (click)="openAccordion($event)">
          <span  data-name="brands" (click)="clickSpan($event)"  style="margin-left: 3.8px;" class="category">Brands</span>
          <span  data-name="brands" class="add" #add  (click)="clickSpan($event)"></span>
          <span  data-name="brands" #accordionDescription class="accordion-description" (click)="clickSpan($event)"></span>
        </button>
        <div  data-name="brands" class="panel">
          <div data-name="brands" class="box">
            @for (brand of menuService.itemBrands; track brand; let i = $index) {
              <div data-name="brands" class="subcategoryBox"  (click)="selectedSubCategory($event)" [id]="brand.id">{{brand.name.translations[translationService.getLanguage()]}}</div>
            }
          </div>
        </div>
      }
      @for (category of  menuService.itemCategories; track category; let i = $index) {
        <button  [attr.data-name]="category.id" class="accordion" (click)="openAccordion($event)">
          <span  [attr.data-name]="category.id" (click)="clickSpan($event)"  style="margin-left: 3.8px;" class="category">{{category.name.translations[translationService.getLanguage()]}}</span>
          <span  [attr.data-name]="category.id" class="add" #add  (click)="clickSpan($event)"></span>
          <span  [attr.data-name]="category.id" #accordionDescription class="accordion-description" (click)="clickSpan($event)"></span>
        </button>
        <div  [attr.data-name]="category.id" class="panel">
          <div [attr.data-name]="category.id" class="box">
            @for (subcategory of  menuService.itemSubCategories; track subcategory; let i = $index) {
              @if (subcategory.itemCategoryId==category.id) {
                <div [attr.data-name]="category.id" class="subcategoryBox" [id]="subcategory.id"  (click)="selectedSubCategory($event)">{{subcategory.name.translations[translationService.getLanguage()]}}</div>
              }
            }
          </div>
        </div>
      }
      <div class="done" >
        <div>{{menuService.sortedMenu.length}} Results</div>
      </div>
    </div>
  </div>
</div>
}
